<template>
    <form @submit.prevent="submit" ref="form">
        <text-input v-model="form.title" :errors="$page.props.errors.title" class="mb-3" label="Titel" />

        <select-input
            :value="form.category"
            v-model="form.category"
            :options="Object.values(categories)"
            :error="$page.props.errors.category_id"
            class="mb-3"
            label="Rubriek"
        ></select-input>

        <wysiwyg :value="form.intro" v-model="form.intro" :error="$page.props.errors.intro" label="Intro"></wysiwyg>

        <wysiwyg  :value="form.body" v-model="form.body" :error="$page.props.errors.body" label="Omschrijving" :insert-media="true" imageable-type="blog"></wysiwyg>

        <file-input
            v-model="form.image"
            :errors="$page.props.errors.image"
            class="mt-3 pr-6 pb-8 w-full lg:w-1/2"
            type="file"
            accept="image/*"
            label="Afbeelding"
            :data-preview-img="blog.img"
        />

        <button type="submit" class="mt-5 text-white bg-teal-700 px-5 py-3 rounded inline-block hover:bg-teal-800 focus:bg-teal-800">
            <i class="fal mr-1" :class="loading == 'submit' ? 'fa-spinner fa-spin' : 'fa-save'"></i>Opslaan
        </button>
    </form>
</template>

<script>
import Layout from "@/admin/Shared/Layout";
import TextInput from "@/admin/Shared/TextInput";
import SelectInput from "@/admin/Shared/SelectInput";
import Helpers from "@/admin/Mixins/GeneralHelpers.js";
import FileInput from "@/admin/Shared/FileInput";
import wysiwyg from "@/admin/Shared/WYSIWYG";

export default {
    components: {
        TextInput,
        SelectInput,
        FileInput,
        wysiwyg
    },

    mixins: [Helpers],

    props: {
        dataLoading: false,
        blog: {
            type: Object,
            default() {
                return {};
            }
        },
        categories: Array
    },

    watch: {
        dataLoading: function(loading) {
            this.loading = loading;
        }
    },

    // remember: "form",

    data() {
        return {
            form: {
                title: this.blog.title || "",
                image: this.blog.image || null,
                body: this.blog.body || "",
                intro: this.blog.intro || "",
                category: this.blog.category || ""
            }
        };
    },

    methods: {
        submit() {
            var data = new FormData();

            data.append("title", this.form.title);
            data.append("intro", this.form.intro || "");
            data.append("body", this.form.body || "");
            data.append("image", this.form.image || "");
            data.append("category_id", this.form.category ? this.form.category.id : "");

            this.$emit("submit", data);
        }
    }
};
</script>
